<template>
  <div>
    <title-edit header="Banner" />
    <line-hr />
    <br />
    <div class="row">
      <v-col class="label" cols="12" sm="3">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch v-model="form.is_active" label="Active"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col class="label" cols="12" sm="3">
        <label>Branch * :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option
          :items="optionBranch"
          :model="form.branch_id"
          @update="updateBranch"
        />
      </v-col>
    </div>
    <div class="row">
      <v-col class="label" cols="12" sm="3">
        <label>Title * :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title" @update="updateTitle" />
      </v-col>
    </div>
    <!--    <div class="row">-->
    <!--      <v-col cols="12" sm="3"  class="label">-->
    <!--        <label>Effect :</label>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" sm="8"  xs="12">-->
    <!--        <select-option :items="optionEffect" :model="form.effect" @update="updateEffect"/>-->
    <!--      </v-col>-->
    <!--    </div>-->
    <div class="row">
      <v-col class="label" cols="12" sm="3">
        <label>Time effect :</label>
      </v-col>
      <v-col cols="12" sm="4" xs="12">
        <input-text-field
          :model="form.time_effect"
          @update="updateTimeEffect"
        />
      </v-col>
      <v-col cols="12" sm="4" xs="12">
        <label>Second</label>
      </v-col>
    </div>
    <!--  BANNER  -->
    <draggable
      :list="form.banner"
      class="list-group"
      ghost-class="ghost"
      :move="checkMove"
      @start="dragging = true"
      @end="dragging = false"
    >
      <div v-for="(itemForm, index) in form.banner" :key="index">
        <p style="font-size: 20px;font-weight: bold">
          Banner No. {{ index + 1 }}
        </p>
        <v-row
          class="row my-5 mx-5"
          style="background-color: #9E9E9E;border: black 1px solid;border-radius: 15px"
        >
          <!--   Banner TH     -->
          <v-col cols="12" lg="6" md="6" sm="6" xl="6">
            <v-row>
              <v-col cols="6" lg="6" md="6" sm="6" xl="6">
                <div>
                  <label>Banner desktop TH* : </label>
                  <div style="color: #2E8037; font-size: 12px">
                    *รองรับ JPEG ,PNG ขนาดไฟล์ 1,280 x 425 px
                  </div>
                </div>
                <span v-if="itemForm.banner_desktop_th">
                  <div>
                    <v-btn
                      fab
                      x-small
                      style="left:90% ;top:5%;position: relative;"
                      @click="removeDesktopImage_th(index)"
                    >
                      <v-icon class="fas fa-times"></v-icon>
                    </v-btn>
                    <img
                      :src="url + itemForm.banner_desktop_th"
                      height="auto"
                      title="click for remove image"
                      width="100%"
                    />
                  </div>
                </span>
                <span v-else>
                  <input-image-upload
                    id="desktop_image_th"
                    width="100%"
                    height="150px"
                    @update="updateBannerDesktop_th({ $event, index })"
                  />
                </span>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xl="6">
                <div>
                  <label>Banner mobile TH* : </label>
                  <div style="color: #2E8037; font-size: 12px">
                    *รองรับ JPEG ,PNG ขนาดไฟล์ 1,080 x 1,080 px
                  </div>
                </div>
                <div style="width: 100%">
                  <span v-if="itemForm.banner_mobile_th">
                    <v-btn
                      fab
                      x-small
                      style="left:90% ;top:5%;position: relative;"
                      @click="removeMobileImage_th(index)"
                    >
                      <v-icon class="fas fa-times"></v-icon>
                    </v-btn>
                    <img
                      :src="url + itemForm.banner_mobile_th"
                      height="100%"
                      title="click for update image"
                      width="100%"
                    />
                  </span>
                  <span v-else>
                    <input-image-upload
                      id="modile_image_th"
                      width="100%"
                      height="150px"
                      @update="updateBannerMobile_th({ $event, index })"
                    />
                  </span>
                </div>
              </v-col>
              <v-col class="my-3" cols="12" lg="12" md="12" sm="12" xl="12">
                <input-text-field
                  :model="itemForm.banner_th_url"
                  @update="itemForm.banner_th_url = $event"
                />
              </v-col>
            </v-row>
          </v-col>
          <!--   Banner EN     -->
          <v-col cols="12" lg="6" md="6" sm="6" xl="6">
            <v-row>
              <v-col cols="6" lg="6" md="6" sm="6" xl="6">
                <div>
                  <label>Banner desktop EN* : </label>
                  <div style="color: #2E8037; font-size: 12px">
                    *รองรับ JPEG ,PNG ขนาดไฟล์ 1,280 x 425 px
                  </div>
                </div>
                <span v-if="itemForm.banner_desktop_en">
                  <v-btn
                    fab
                    x-small
                    style="left:90% ;top:5%;position: relative;"
                    @click="removeDesktopImage_en(index)"
                  >
                    <v-icon class="fas fa-times"></v-icon>
                  </v-btn>
                  <img
                    :src="url + itemForm.banner_desktop_en"
                    height="auto"
                    title="click for remove image"
                    width="100%"
                  />
                </span>
                <span v-else>
                  <input-image-upload
                    id="desktop_image_en"
                    width="100%"
                    height="150px"
                    @update="updateBannerDesktop_en({ $event, index })"
                  />
                </span>
              </v-col>
              <v-col cols="6" lg="6" md="6" sm="6" xl="6">
                <div>
                  <label>Banner mobile EN* : </label>
                  <div style="color: #2E8037; font-size: 12px">
                    *รองรับ JPEG ,PNG ขนาดไฟล์ 1,080 x 1,080 px
                  </div>
                </div>
                <div style="width: 100%">
                  <span v-if="itemForm.banner_mobile_en">
                    <v-btn
                      fab
                      x-small
                      style="left:90% ;top:5%;position: relative;"
                      @click="removeMobileImage_en(index)"
                    >
                      <v-icon class="fas fa-times"></v-icon>
                    </v-btn>
                    <img
                      :src="url + itemForm.banner_mobile_en"
                      height="auto"
                      title="click for remove image"
                      width="100%"
                    />
                  </span>
                  <span v-else>
                    <input-image-upload
                      id="modile_image_en"
                      width="100%"
                      height="150px"
                      v-model="itemForm.banner_mobile_en"
                      @update="updateBannerMobile_en({ $event, index })"
                    />
                  </span>
                </div>
              </v-col>
              <v-col class="my-3" cols="12" lg="12" md="12" sm="12" xl="12">
                <input-text-field
                  :model="itemForm.banner_en_url"
                  @update="itemForm.banner_en_url = $event"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </draggable>

    <v-btn
      class="btn v-btn--outlined"
      @click="addMoreBanner()"
      style=";border: #fb8c00 2px solid"
    >
      <v-icon class="fas fa-plus-circle"></v-icon>&nbsp;เพิ่มBanner
    </v-btn>
    <br />
    <line-hr />
    <command-button
      @delete-info="deleteBanner"
      @save-info="saveBanner"
      @save-close="saveClose"
    ></command-button>
    <!--    <pre>{{ form }}</pre>-->
  </div>
</template>

<script>
import TitleEdit from "../../components/TitleHeader/TitleEdit";
import LineHr from "../../components/Icon/line-hr";
import SelectOption from "../../components/Input/selectOption";
import InputTextField from "../../components/Input/InputTextField";
import DeleteButton from "../../components/Button/DeleteButton";
import PreviewButton from "../../components/Button/PreviewButton";
import SaveButton from "../../components/Button/SaveButton";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import InputImageUpload from "../../components/Input/InputImageUpload";
import { permissionBanner, role } from "../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../components/Layout/CommandButton";
import { url } from "@/util/Constants";
export default {
  name: "BannerEdit",
  components: {
    CommandButton,
    InputImageUpload,
    SaveButton,
    draggable,
    PreviewButton,
    DeleteButton,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit
  },
  data() {
    return {
      enabled: false,
      list: [],
      dragging: false,
      url: url,
      permission: null,
      is_new_banner: false,
      optionCategory: [],
      optionBranch: [],
      optionEffect: [
        { value: null, text: "Select" },
        { value: 1, text: "Cube" },
        { value: 2, text: "Fade" },
        { value: 3, text: "Slide" }
      ],
      // banner_desktop_th: null,
      // banner_desktop_en: null,
      // banner_mobile_th: null,
      // banner_mobile_en: null,
      // banner_th_url: null,
      // banner_en_url: null,
      save_id: null
    };
  },
  computed: {
    permissionBanner,
    ...mapState({
      form: state => {
        return state.Banner.form;
      },
      edited_id: state => {
        return state.Banner.edited_id;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateData() {
      if (!this.form.branch_id && this.form.branch_id !== 0) {
        Swal("", "Please Select Branch", "error");
        return false;
      } else if (!this.form.title) {
        Swal("", "Please Select Title", "error");
        return false;
      } else {
        return true;
      }
    },
    addMoreBanner() {
      this.form.banner.push({
        banner_id: this.form.branch.id,
        banner_desktop_th: null,
        banner_desktop_en: null,
        banner_mobile_th: null,
        banner_mobile_en: null,
        banner_en_url: null,
        banner_th_url: null
      });
    },
    saveClose() {
      if (this.validateData()) {
        this.form.edited_id = this.edited_id ? this.edited_id : "";
        this.$store
          .dispatch("Banner/saveBanner", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            Swal(res.response_msg);
            if (res.response_code == 200) {
              this.goToBanner();
            }
          })
          .catch(() => {
            Swal("", "Cannot save Banner data", "error");
          });
      }
    },
    saveBanner() {
      if (this.validateData()) {
        this.form.edited_id = this.edited_id ? this.edited_id : "";
        this.$store
          .dispatch("Banner/saveBanner", {
            id: this.save_id ? this.save_id : this.form.id,
            data: this.form
          })
          .then(res => {
            this.$store
              .dispatch("Banner/showBanner", this.form.id)
              .then(res => {
                if (res.response_code == 200) {
                  Swal("", "Success", "success");
                  this.goToBanner();
                  // this.$store.dispatch("Banner/setFormBanner", res.result);
                }
              });
            this.save_id = res.result.id;
            Swal(res.response_msg);
          })
          .catch(() => {
            Swal("", "Cannot save Banner data", "error");
          });
        this.is_new_banner = false;
      }
    },
    goToBanner() {
      this.$router.push("/banner");
    },
    deleteBanner() {
      this.$store
        .dispatch("Banner/deleteBanner", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToBanner();
          }
        })
        .catch(() => {
          Swal("", "Cannot delete Banner data", "error");
        });
    },
    updateBranch(val) {
      console.log("updateBranch", val);
      this.form.branch_id = val;
    },
    updateTitle(val) {
      this.form.title = val;
    },
    updateEffect(val) {
      this.form.effect = val;
    },
    updateTimeEffect(val) {
      this.form.time_effect = val;
    },
    updateBannerDesktop_th(val) {
      return (this.form.banner[val.index].banner_desktop_th =
        val.$event.imagePath);
    },
    updateBannerMobile_th(val) {
      return (this.form.banner[val.index].banner_mobile_th =
        val.$event.imagePath);
    },
    updateBannerDesktop_en(val) {
      return (this.form.banner[val.index].banner_desktop_en =
        val.$event.imagePath);
    },
    updateBannerMobile_en(val) {
      return (this.form.banner[val.index].banner_mobile_en =
        val.$event.imagePath);
    },
    removeMobileImage_th(index) {
      return (this.form.banner[index].banner_mobile_th = null);
    },
    removeDesktopImage_th(index) {
      return (this.form.banner[index].banner_desktop_th = null);
    },
    removeMobileImage_en(index) {
      return (this.form.banner[index].banner_mobile_en = null);
    },
    removeDesktopImage_en(index) {
      return (this.form.banner[index].banner_desktop_en = null);
    }
  }
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #c6beb8;
}
img {
  object-fit: cover;
  border: #9e9e9e solid 1px;
  border-radius: 10px;
}
</style>
